import { Command } from '@/app/tracking/api';
import { GradingMethod } from './grading-method';
import { ExamRole } from './role'
import { ExamResult } from './exam-result'

export interface CompleteExamTrackingCommandPayload {
  id: string
  attempt: Attempt
  effectiveGrading: GradingMethod
  meta: ExamMeta
}

export interface ExamMeta {
  title: string;
  role: ExamRole
}

interface Attempt {
  timestamp: Date
  score: {
    min: number,
    raw: number,
    max: number
  }
  passingScore: number
  result: ExamResult
  durationSeconds: number
}

export const CompleteExamTrackingCommandName = 'complete-exam' as const;
export type CompleteExamTrackingCommand =
      Command<typeof CompleteExamTrackingCommandName, CompleteExamTrackingCommandPayload>;
